import { render, staticRenderFns } from "./SendFormBuilderAction.vue?vue&type=template&id=4ec4acfe&scoped=true"
import script from "./SendFormBuilderAction.vue?vue&type=script&lang=js"
export * from "./SendFormBuilderAction.vue?vue&type=script&lang=js"
import style0 from "./SendFormBuilderAction.vue?vue&type=style&index=0&id=4ec4acfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec4acfe",
  null
  
)

export default component.exports